import WordService from "@/services/WordService";
import Sentence from "@/components/Sentence/Sentence.vue";
import { root } from "@/common/consts";
import RelatedInfo from "@/components/RelatedInfo/RelatedInfo.vue";

export default {
    components: {
        Sentence,
        RelatedInfo
    },
    props: {
        slug: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            word: "",
            sentencesExamples: [],
            moreSentences: `${root.SENTENCES}${this.$route.path}`,
            title: this.$t("thesaurusSentenceExampleCard"),
            error: false
        };
    },
    created() {
        WordService.getSentences(this.slug, 5).then(
            res => {
                const sentencesExamples = res.data.data;
                this.sentencesExamples = sentencesExamples.sentences;
                this.word = sentencesExamples.headword;
            },
            err => (this.error = true)
        );
    }
};



// WEBPACK FOOTER //
// ./src/components/SentencesExamples/SentencesExamples.js